// extracted by mini-css-extract-plugin
export default {"article":"Profile_article__Lqb20","profile-form-container":"Profile_profile-form-container__145iK"};